import React from 'react'
import SendIcon from '@mui/icons-material/Send';
import { ReactComponent as Percent } from "assets/svg/percent.svg"
import { ReactComponent as Send } from "assets/svg/send.svg"
import { ReactComponent as DoubleCheck } from "assets/svg/doubleCheck.svg"

import styles from "./AnnouncementDetails.module.scss"
const LogoContainer = ({
    count,
    type
}) => {
    return (
        <div className={styles?.logoContainer}>
            <div className={styles?.logo}>
                <span className={styles?.logo_circle}
                    style={{
                        backgroundColor:
                            type === "RecipientsCount" ?
                                "#6666FF"
                                : type === "openCount" ?
                                    "#0092FF" :
                                    "#F15C80"
                    }}
                >
                    {
                        type === "RecipientsCount" ?
                            <Send style={{ color: "white" }} />
                            : type === "openCount" ?
                                <DoubleCheck style={{ color: "white" }} />
                                :
                                <Percent style={{ color: "white" }} />
                    }
                </span>
                <div className={styles?.logo_content}>
                    <p style={{ fontWeight: "bold" }}>{count}</p>
                    <p>
                        {
                            type === "RecipientsCount" ?
                                "Recipients"
                                : type === "openCount" ?
                                    "Open Count" :
                                    "Open Rate"
                        }
                    </p>
                </div>
            </div>

        </div>
    )
}

export default LogoContainer